import { css, SerializedStyles } from '@emotion/react';

import styled from '@emotion/styled';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { CountryFlagIcon } from 'src/ui/assets/icons/flags/CountryFlagIcon';

import { withConfig } from 'src/withConfig';



interface EventListPropsType {

    variant: DefaultComponentVariantType | null;

}



const setEventListWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            display: flex;

            flex-flow: column nowrap;

            gap: ${theme.star.gap.medium};

            padding: ${theme.star.padding.medium};

            background-color: ${theme.star.eventsTableColors.bgColor};

            @media ${theme.star.mediaQuery.tablet} {

                margin: 0 8px;

                border-radius: 0 0 ${theme.star.radius.medium} ${theme.star.radius.medium};

            }

        `;

    }

    if (variant === DefaultComponentVariantType.TERTIARY) {

        return css`

            &.event-list--empty {

                display: flex;

                flex-flow: column;

                align-self: stretch;

                flex: 1;

            }



            &.event-list--outrights {

                [class$='EventRowWrapper'] {

                    border-bottom: none;

                    min-height: auto;

                }



                [class$='CollapseWrapper'] {

                    border-bottom: 1px solid ${theme.star.unified.collapse.borderColor};

                }



                [class$='EventRowHeader'] {

                    padding: ${theme.star.padding.medium};

                    font-size: 1.4rem;

                    font-weight: ${theme.star.unified.eventRow.typography.fontWeightSecondary};

                    line-height: ${theme.star.unified.eventRow.typography.lineHeightPrimary};

                }



                [class$='SelectionsGroupWrap'] [class$='Empty'] {

                    flex-flow: column;

                    gap: 0;

                }

                & [class$='EventHeaderCaptionWrapper'] {

                    display: none;

                }

                & [class$='Empty'] [class$='SelectionsGroupLiItem'] {

                    border-radius: 0;

                    padding: 8px;

                    border-bottom: 1px solid ${theme.star.unified.eventRow.borderColor};

                }

                & [class$='SelectionsGroupWrapper'] {

                    flex-flow: column;

                }

            }

        `;

    }

    return css``;

};



export const EventListWrapper = withConfig(theme => styled('section', { label: 'EventListWrapper' })<EventListPropsType>`

    ${({ variant }): SerializedStyles => setEventListWrapper(variant, theme)}

    font-size: ${theme.star.fontSize.xRegular};

    overflow: hidden;

`);





const setCompetitionWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            display: flex;

            flex-flow: column nowrap;

            gap: ${theme.star.gap.medium};

        `;

    }

    return css``;

};



export const CompetitionWrapper = withConfig(theme => styled('div', { label: 'CompetitionWrapper' })<EventListPropsType>`

    ${({ variant }): SerializedStyles => setCompetitionWrapper(variant, theme)}

`);



const setEventsListGroupWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            display: flex;

            flex-flow: column nowrap;

            gap: ${theme.star.gap.small};

        `;

    }

    return css``;

};



export const EventsListGroupWrapper = withConfig(theme => styled('div', { label: 'EventsListGroupWrapper' })<EventListPropsType>`

    ${({ variant }): SerializedStyles => setEventsListGroupWrapper(variant, theme)}

`);





const setEventsListCompetitionGroupItemWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            display: flex;

            flex-flow: column nowrap;

            gap: ${theme.star.gap.medium};

        `;

    }

    return css``;

};



export const EventsListCompetitionGroupItemWrapper = withConfig(theme => styled('div', { label: 'EventsListCompetitionGroupItemWrapper' })<EventListPropsType>`

    ${({ variant }): SerializedStyles => setEventsListCompetitionGroupItemWrapper(variant, theme)}

`);



export const CompetitionFlag = styled(CountryFlagIcon, { label: 'CompetitionFlag' })`

    flex-shrink: 0;

`;



export const FeaturedSection = withConfig(theme => styled('section', { label: 'FeaturedSection' })`

    & [class$='TableSportsRowLinkWrapper'] {

        padding: ${theme.star.padding.medium};

        border: 0;

        border-bottom: 1px solid ${theme.star.unified.eventRow.borderColor};

        flex-flow: row;

        align-items: center;



        & [class$='RowLinkLabel'] {

            font-size: ${theme.star.unified.tableSportsRow.link.typography.fontSizePrimary};

            font-weight: ${theme.star.unified.tableSportsRow.link.typography.fontWeightPrimary};

            line-height: ${theme.star.unified.tableSportsRow.link.typography.lineHeightPrimary};

            display: flex;

            align-items: center;

            min-height: 44px;

        }

    }

`);